"use strict";
// import { StateReducers } from 'state/reducers/types/StateReducers'
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceUserWatcherMapState = void 0;
var WorkspaceUserWatcherMapState = function () {
    // const currentLocation = state.currentLocation || undefined
    // const isRoutes = currentLocation && currentLocation.isRoutes
    // return { isRoutes }
    return {};
};
exports.WorkspaceUserWatcherMapState = WorkspaceUserWatcherMapState;
